import { Injectable, EventEmitter } from '@angular/core';
import { ConfigService } from '@ngx-config/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { TranslateService } from 'shared/translate';
import { BaseService } from './base.service';
import { ItemLista } from 'shared/entities/itemlista.entity';
import { Observable, Subject } from 'rxjs';
import { enumTransacao } from 'shared/domains/enumtransacao.enum';


@Injectable(
    {
        providedIn: 'root'
      }
)

export class PlataformaService extends BaseService {

    constructor(private http: HttpClient, readonly config: ConfigService) {
        super(config)
        this.apiUrl += 'Plataforma';
       
    }

    public Nome: string = "";
    public Ambiente: string = null;
    public CodigoAcao: string=null;
    public TelaInicial: enumTransacao=null;
    public PaginaRedirecionamento: string=null;    
  

    ListarEnum(Enumerador: string, CodigosIgnorar?: number[], CodigosPesquisar?: number[], OrdenarNome?: boolean): Observable<ItemLista[]> {
        let params = new HttpParams();
        var url: string = this.apiUrl + "/ListarEnum/" + Enumerador
        if (CodigosIgnorar && CodigosIgnorar.length > 0)
            CodigosIgnorar.forEach(d => {
                params = params.append("CodigosIgnorar", d.toString());
            });
        if (CodigosPesquisar && CodigosPesquisar.length > 0)
            CodigosPesquisar.forEach(d => {
                params = params.append("CodigosPesquisar", d.toString());
            });
        if (OrdenarNome)
            params = params.set("OrdenarNome", OrdenarNome.toString());

        return this.http.get<ItemLista[]>(url, { params: params });
    }

    RetornarDescricaoEnum(Enumerador: string, Codigo: number): Observable<string> {
        var url: string = this.apiUrl + "/RetornarEnum/" + Enumerador + "/" + Codigo.toString();
        return this.http.get(url, { responseType: 'text' });

    }

    PossuiInformacaoLegal(): Observable<boolean>{
        var url: string = this.apiUrl + "/PossuiInformacaoLegal";
        return this.http.get<boolean>(url);
    }

    RetornarLinkInformacaoLegal(): string{
        var url: string = this.apiUrl + "/InformacaoLegal";
        return url;
    }
 
    RetornarChavePublica(): Observable<string> {
        var url: string = this.apiUrl + "/RetornarChavePublica/";
        return this.http.get(url, { responseType: 'text' });

    }



}